import request from '@/utils/http.js';

/**
 * 用户创建举报
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
const createFeedback = (data = {}) => {
  const url = '/v3/interacts/report-feedback/create';
  return request({
    url,
    method: 'POST',
    data,
  });
};
const getReportReasonList = (params = {}) => {
  const url = '/v3/interacts/report-feedback/get-reason-type-list';
  return request({
    url,
    method: 'GET',
    params,
  });
}

export default {
  createFeedback,
  getReportReasonList
};
